import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ChevronRight as ChevronRightIcon, Home as HomeIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
  icon?: React.ReactNode;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  homePath?: string;
}

/**
 * Fil d'Ariane pour la navigation contextuelle
 */
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, homePath = '/dashboard' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mb: 3,
        flexWrap: 'wrap',
      }}
    >
      <IconButton
        component={RouterLink}
        to={homePath}
        size="small"
        sx={{
          color: '#129baf',
          '&:hover': {
            background: 'rgba(18, 155, 175, 0.1)',
          },
        }}
        title="Accueil"
      >
        <HomeIcon fontSize="small" />
      </IconButton>

      <ChevronRightIcon sx={{ color: 'text.secondary', fontSize: '1rem' }} />

      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          {item.path && index < items.length - 1 ? (
            <>
              <Box
                component={RouterLink}
                to={item.path}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  color: 'text.secondary',
                  textDecoration: 'none',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  '&:hover': {
                    color: '#129baf',
                  },
                }}
              >
                {item.icon && item.icon}
                <Typography component="span">{item.label}</Typography>
              </Box>
              <ChevronRightIcon sx={{ color: 'text.secondary', fontSize: '1rem' }} />
            </>
          ) : (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                color: '#129baf',
                fontWeight: 600,
                fontSize: '0.875rem',
              }}
            >
              {item.icon && item.icon}
              <Typography component="span">{item.label}</Typography>
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default Breadcrumbs;
